import { z } from "zod";
import { ResolvedFeatureConfigAdminViewSchema } from "./resolved-feature-config.schemas.js";
import type { BaseFeatureConfig } from "./base-feature-config.schemas.js";
import type { JsonValueType } from "../types/json-value.types.js";
import type { FeatureKey } from "./feature-key.schemas.js";

export const EventFeaturePresetKeySchema = z.enum([
  "FEATURE_FULL",
  "FEATURE_MINIMAL",
]);

export type EventFeaturePresetKey = z.infer<typeof EventFeaturePresetKeySchema>;

export type EventFeaturePresetConfig = BaseFeatureConfig & {
  readonly [key: string]: JsonValueType;
};

export interface EventFeaturePresetConfigItem {
  readonly featureKey: FeatureKey;
  readonly config: EventFeaturePresetConfig;
}

export interface EventFeaturePresetDefinition {
  readonly key: EventFeaturePresetKey;
  readonly name: string;
  readonly description: string;
  readonly configs: readonly EventFeaturePresetConfigItem[];
}

export interface EventFeaturePresetPreviewItem {
  readonly featureKey: FeatureKey;
  readonly currentConfig: EventFeaturePresetConfig;
  readonly targetConfig: EventFeaturePresetConfig;
  readonly willChange: boolean;
}

export interface EventFeaturePresetPreview {
  readonly preset: EventFeaturePresetDefinition;
  readonly items: readonly EventFeaturePresetPreviewItem[];
}

export const EventFeaturePresetApplyResultSchema = z.object({
  presetKey: EventFeaturePresetKeySchema,
  configs: z.array(ResolvedFeatureConfigAdminViewSchema).readonly(),
});

export type EventFeaturePresetApplyResult = z.infer<
  typeof EventFeaturePresetApplyResultSchema
>;
